import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../../interfaces/auth";
import { changeStatusResponsibilityThunk } from "../../../asyncThunks/manage/mapping";

const initialState: defaultState = {
    error: null,
    data: null,
    loading: false,
};

export const StatusResponsibility = createSlice({
    name: "StatusResponsibility",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(changeStatusResponsibilityThunk.pending, (state, action) => {
            state.error = null;
            state.data = null;
            state.loading = true;
        });
        builder.addCase(changeStatusResponsibilityThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = null;
            }
            state.loading = false;
        });
        builder.addCase(changeStatusResponsibilityThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = null;
            state.loading = false;
        });
    },
});

export default StatusResponsibility.reducer;
